import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              从零到成品，让你的故事动起来。<br />
              为同人动画创作者提供最全面的指南和资源。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/tutorials" className="text-foreground-400 hover:text-accent-300 text-sm transition-colors">动画制作教程</Link>
              <Link to="/category/software" className="text-foreground-400 hover:text-accent-300 text-sm transition-colors">软件推荐</Link>
              <Link to="/category/platforms" className="text-foreground-400 hover:text-accent-300 text-sm transition-colors">投稿平台</Link>
              <Link to="/category/tips" className="text-foreground-400 hover:text-accent-300 text-sm transition-colors">创作心得</Link>
              <Link to="/category/community" className="text-foreground-400 hover:text-accent-300 text-sm transition-colors">社群动态</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-foreground-400 hover:text-accent-300 text-sm transition-colors">品牌介绍</Link>
              <span className="text-foreground-400 text-sm">联系邮箱：{siteInfo.contact.email}</span>
              <span className="text-foreground-400 text-sm">微博：{siteInfo.contact.weibo}</span>
              <span className="text-foreground-400 text-sm">B站：{siteInfo.contact.bilibili}</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">关注我们</h4>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="Email">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-foreground-500 text-sm">
            <p>&copy; {currentYear} {siteInfo.name}. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-accent-300 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-accent-300 transition-colors" rel="nofollow">使用条款</a>
              <Link to="/about" className="hover:text-accent-300 transition-colors">联系我们</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}